import { render, staticRenderFns } from "./trending.vue?vue&type=template&id=089b63dc&"
import script from "./trending.vue?vue&type=script&lang=ts&"
export * from "./trending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports